import { render, staticRenderFns } from "./Windturbine2.vue?vue&type=template&id=432804cf&"
import script from "./Windturbine2.vue?vue&type=script&lang=ts&"
export * from "./Windturbine2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports